export const AUTOCOMPLETE_PAPER_STYLE = { backgroundColor: '#373737', color: 'white' };
